<template>
  <v-content class="pl-0 pt-2">
    <p class="display-3 text-center">Sziládi Gyula gumiszerelő mester</p>
    <v-container class="grey lighten-3">
      <v-row>
        <v-col cols="3">
          <v-img :src="logo" max-height="200px" contain />
          <p class="text-center display-5">
            Nyitva: H-P 8:00-17:00, Szo 8-12 időpont egyeztetés alapján a +36203822965, +36703825461
            számokon
          </p>
          <template>
            <!--            <v-btn class="mb-2" block color="indigo" dark>Galéria</v-btn>-->
            <app-modal></app-modal>
            <v-btn block @click.stop="drawer = !drawer" color="indigo" dark
              >Menü</v-btn
            >
          </template>
        </v-col>
        <v-col cols="9">
          <p class="display-1 text-center">
            Gumiszerelés, centírozás 20 inch átmérőig, 11 inch szélességig
          </p>
          <div class="row">
            <div class="col-md-6">
              <div class="map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2690.2683091187373!2d17.627705615152692!3d47.60147229632618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476bc177638e7035%3A0x6dc2ade571058de9!2zR3nFkXLDumpiYXLDoXQsIE3DqWx5a8O6dCB1LiA3NSwgOTA4MQ!5e0!3m2!1shu!2shu!4v1587217840312!5m2!1shu!2shu"
                  width="400"
                  height="300"
                  style="border:0;"
                  allowfullscreen=""
                  aria-hidden="false"
                  tabindex="0"
                ></iframe>
              </div>
            </div>
            <div class="col-md-6">
              <iframe
                src="https://www.google.com/maps/embed?pb=!4v1587220557689!6m8!1m7!1s9IHHTzAdk48ViS06rs3JMw!2m2!1d47.601461002607!2d17.62983767179054!3f67.51392!4f0!5f0.7820865974627469"
                width="400"
                height="300"
                style="border:0;"
                allowfullscreen=""
                aria-hidden="false"
                tabindex="0"
              ></iframe>
            </div>
          </div>
          <!-- row -->
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import ModalGalery from "@/components/home/Modal/ModalGalery";

export default {
  name: "HomeContent",
  components: {
    "app-modal": ModalGalery
  },
  data: function() {
    return {
      logo: require("@/assets/headlogo.png")
    };
  }
};
</script>

<style scoped></style>
